/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentOptimizationRunsPathParams = NonNullable<
  operations['listAgentOptimizationRuns']['parameters']['path']
>;

export type ListAgentOptimizationRunsQueryParams = NonNullable<
  operations['listAgentOptimizationRuns']['parameters']['query']
>;

export interface Input extends ListAgentOptimizationRunsPathParams {
  apiVersion?: string;
  query?: ListAgentOptimizationRunsQueryParams;
}

export async function listAgentOptimizationRuns(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-optimizations/{optimizationKey}/runs', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
